module.exports = __webpack_public_path__ + "62fa946bbd0e0067a77463afd959f6de.png";